import { useQueryClient } from 'react-query'
import { ITeamMember } from 'types'
import { queryKeys } from 'queries/queryKeys'

export const useTeamMembers = () => {
  const queryClient = useQueryClient()
  const data = queryClient.getQueryData<ITeamMember[]>(queryKeys.TEAM_MEMBERS)
  return data ?? []
}
